import { render } from "./StartView.vue?vue&type=template&id=3c6c7e48&ts=true"
import script from "./StartView.vue?vue&type=script&lang=ts"
export * from "./StartView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__